module.exports = __webpack_public_path__ + "static/media/level-3.2a305d7e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/floorplans/floorplates/level-3.svg
// module id = 582
// module chunks = 0